
import { getData } from "../apiClient";

const ItemName = "Booking Report";
const API_URL = "booking-report";

// get all with pagination
export const GetAll = async (
  {
    page = 1,
    limit = 10,
    search = "",
    checkout_date = "",
  },
  signal = null
) => {

  const queryParams = new URLSearchParams({
    page,
    limit,
    search,
    checkout_date,
  });

  return await getData(
    `/booking-report/checkout-report/?${queryParams}`,
    {},
    {},
    signal
  );
};

// Fetch Daily Business Report / Check-in date wise report
export const GetDailyBusinessReport = async (
  { checkinDate = "" },
  signal = null
) => {
  const queryParams = new URLSearchParams();
  if (checkinDate) {
    queryParams.append("checkinDate", checkinDate);
  }

  return await getData(
    `/booking-report/daily-business-report?${queryParams.toString()}`,
    {},
    {},
    signal
  );
};

